import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { graphql } from 'react-apollo';
import { currentUserQuery } from '../queries';

class RedirectRoute extends React.Component {

  constructor(props){
    super(props);

    this.state = {
      newUser: false
    }
  }

  componentWillMount() {
    if (this.props.location.state && this.props.location.state.newUser) {
      this.setState({newUser: true})
    }
  }

  render() {
    const { component: Component, data: { currentUserContext },  ...rest } = this.props;
    this.props.data.refetch();
    return (
      <div>
        { currentUserContext &&
        <Route
          {...rest}
          render={props =>
            ((currentUserContext.uid !== 0 && !currentUserContext.fieldVatNumber)
                ? <Redirect to="/complete-registration"/>
                : <Component currentUser={currentUserContext} {...props} newUser={this.state.newUser} />
            )}
        />
        }
      </div>)
  };
}

export default graphql(
  currentUserQuery, {
  options: { fetchPolicy: 'network-only' },
})(RedirectRoute);


// WEBPACK FOOTER //
// ./src/utils/RedirectRoute.js